<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 6.89a10.9 10.9 0 00-.15-1.79 2 2 0 00-2-1.64H19V3a1 1 0 00-1-1H6a1 1 0 00-1 1v.46h-.9A2 2 0 002.15 5.1 10.81 10.81 0 002 6.89 10 10 0 005 14v7a1 1 0 001 1h12a1 1 0 001-1v-7a10 10 0 003-7.11zM7 7h1v2.5a1.5 1.5 0 003 0V7h6v6.13a8 8 0 01-10 0zm10-3v2h-7v3.5a.5.5 0 01-1 0V6H7V4zM4 6.89a10.94 10.94 0 01.1-1.43H5v5.3a7.93 7.93 0 01-1-3.87zM17 20H7v-4.46a9.93 9.93 0 0010 0zm2-14.55h.87A8.11 8.11 0 0120 6.89a7.93 7.93 0 01-1 3.87z"/></svg>